import { Component, computed, input, Input, InputSignal, Signal } from '@angular/core';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { CommonModule } from '@angular/common';
import { ApplicationSubjectLabelPipe } from '../../../../../../../pipes/application-subject-label.pipe';
import { environment } from '../../../../../../../../environments/environment';
import { ApplicationNotesLabelPipe } from '../../../../../../../pipes/application-notes-label.pipe';

@Component({
  selector: 'app-application-data-preview',
  standalone: true,
  imports: [
    LabelComponent,
    CommonModule,
    ApplicationSubjectLabelPipe,
    ApplicationNotesLabelPipe
  ],
  templateUrl: './application-data-preview.component.html'
})
export class ApplicationDataPreviewComponent {

  public application = input<ApplicationAppEntityApplicationRead | null>(null);

  public applicationSubmittedTo = environment.applicationSubmittedTo;

  public showResponsiblePerson: Signal<boolean> = computed(() =>
    !!this.application()?.responsiblePersonEmail?.length
    && !!this.application()?.responsiblePersonFirstName?.length
    && !!this.application()?.responsiblePersonLastName?.length
  );

  public showManager: Signal<boolean> = computed(() =>
    !!this.application()?.managerEmail?.length
    && !!this.application()?.managerFirstName?.length
    && !!this.application()?.managerLastName?.length
  );

  public showRoadTrafficImpact: Signal<boolean> = computed(() => [
    '/zajecie-pasa-prowadzenie-robot',
    '/zajecie-pasa-umieszczenie-obiektow-budowlanych',
    '/awaryjne-zajecie-pasa-drogowego',
    '/zajecie-pasa-prawa-wylacznosci'
  ].includes(this.application()?.service?.url || ''));

  public showCorrespondenceData: Signal<boolean> = computed(() => ['/zezwolenie-przejazdy-pojazdow-nienormatywnych'].includes(this.application()?.service?.url || ''))

}
